<template>
    <div>
        <button
            @click="isMenuOpen = !isMenuOpen"
            :aria-expanded="isMenuOpen"
            :class="{ 'bg-gray-tier-2 type-primary': isMenuOpen }"
            class="flex items-center justify-center font-medium gap-2 group rounded-full text-xs z-10 w-9 h-9 hover:type-primary hover:bg-gray-tier-2 type-tertiary"
        >
            <BaseSvg
                name="MoreVert"
                :aria-hidden="!isMenuOpen"
                class="size-5"
            />
            <span class="sr-only">More</span>
        </button>
        <Transition name="search-pop">
            <TrayDropdownMenu
                v-click-outside="closeDropdown"
                v-if="isMenuOpen"
                :tray="tray"
                :is-footer-button="isFooterButton"
            />
        </Transition>
    </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import {TrayDropdownMenu} from "@/Components";
import {eventBus} from "@/Composables";

const props = defineProps(['tray','isFooterButton']);
const isMenuOpen = ref(false);

const closeDropdown = () => {
    isMenuOpen.value = false;
}

onMounted(() => {
    eventBus.on('pins:tray-deleted', closeDropdown)
    eventBus.on('pins:dialog-scrolled', closeDropdown)
});

onUnmounted(() => {
    eventBus.off('pins:tray-deleted', closeDropdown)
    eventBus.off('pins:dialog-scrolled', closeDropdown)
});
</script>
